var _defs, _rect, _g, _g2, _g3, _g4, _g5;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgQaTestingIllustration(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 770 445",
    width: 770,
    height: 445,
    role: "img",
    "aria-label": "Software quality assurance: bug inspection under a magnifying glass and a passing test checklist",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "bg",
    x1: 0,
    y1: 0,
    x2: 0,
    y2: 1
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f7f3fd"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ece3fb"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "handle",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 1
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#6a2dec"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9c2ede"
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 770,
    height: 445,
    fill: "url(#bg)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#d9cbf3"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 55,
    cy: 55,
    r: 3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 715,
    cy: 50,
    r: 3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 45,
    cy: 390,
    r: 3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 725,
    cy: 395,
    r: 3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 390,
    cy: 35,
    r: 3
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 70,
    y: 70,
    width: 360,
    height: 250,
    rx: 14,
    fill: "#ffffff"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 70,
    y: 70,
    width: 360,
    height: 40,
    rx: 14,
    fill: "#e5d9f8"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 70,
    y: 96,
    width: 360,
    height: 14,
    fill: "#e5d9f8"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 96,
    cy: 90,
    r: 6,
    fill: "#ff6b6b"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 118,
    cy: 90,
    r: 6,
    fill: "#ffd166"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 140,
    cy: 90,
    r: 6,
    fill: "#4caf7d"
  }), /*#__PURE__*/React.createElement("g", {
    strokeLinecap: "round"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M100 140 h120",
    stroke: "#c6aef0",
    strokeWidth: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100 168 h180",
    stroke: "#e0d4f7",
    strokeWidth: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100 196 h90",
    stroke: "#9c2ede",
    strokeWidth: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100 224 h150",
    stroke: "#e0d4f7",
    strokeWidth: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100 252 h110",
    stroke: "#c6aef0",
    strokeWidth: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100 280 h70",
    stroke: "#e0d4f7",
    strokeWidth: 10
  })))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 345,
    cy: 235,
    r: 72,
    fill: "#ffffff",
    opacity: 0.55
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 345,
    cy: 235,
    r: 72,
    fill: "none",
    stroke: "url(#handle)",
    strokeWidth: 14
  }), /*#__PURE__*/React.createElement("path", {
    d: "M398 288 L452 342",
    stroke: "url(#handle)",
    strokeWidth: 22,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(345,235)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 0,
    cy: 6,
    rx: 20,
    ry: 26,
    fill: "#6a2dec"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 0,
    cy: -24,
    r: 12,
    fill: "#6a2dec"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 -18 v46",
    stroke: "#f3edfc",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-6 -32 l-8 -10 M6 -32 l8 -10",
    stroke: "#6a2dec",
    strokeWidth: 4,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-18 -6 l-16 -8 M-20 8 h-16 M-16 20 l-14 10 M18 -6 l16 -8 M20 8 h16 M16 20 l14 10",
    stroke: "#6a2dec",
    strokeWidth: 4,
    strokeLinecap: "round"
  })))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 500,
    y: 80,
    width: 200,
    height: 240,
    rx: 14,
    fill: "#ffffff"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 560,
    y: 66,
    width: 80,
    height: 28,
    rx: 10,
    fill: "#9c2ede"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 532,
    cy: 140,
    r: 12,
    fill: "#4caf7d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M526 140 l4 5 l8 -9",
    stroke: "#ffffff",
    strokeWidth: 3.5,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M556 140 h116",
    stroke: "#e0d4f7",
    strokeWidth: 10,
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 532,
    cy: 188,
    r: 12,
    fill: "#4caf7d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M526 188 l4 5 l8 -9",
    stroke: "#ffffff",
    strokeWidth: 3.5,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M556 188 h96",
    stroke: "#e0d4f7",
    strokeWidth: 10,
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 532,
    cy: 236,
    r: 12,
    fill: "#4caf7d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M526 236 l4 5 l8 -9",
    stroke: "#ffffff",
    strokeWidth: 3.5,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M556 236 h108",
    stroke: "#e0d4f7",
    strokeWidth: 10,
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 532,
    cy: 284,
    r: 12,
    fill: "none",
    stroke: "#9c2ede",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M556 284 h84",
    stroke: "#e0d4f7",
    strokeWidth: 10,
    strokeLinecap: "round"
  })))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    fontFamily: "Arial, sans-serif",
    fontSize: 16,
    fontWeight: "bold"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 105,
    y: 360,
    width: 90,
    height: 44,
    rx: 12,
    fill: "#ffffff"
  }), /*#__PURE__*/React.createElement("text", {
    x: 150,
    y: 388,
    textAnchor: "middle",
    fill: "#4a3f66"
  }, "Unit"), /*#__PURE__*/React.createElement("rect", {
    x: 225,
    y: 360,
    width: 150,
    height: 44,
    rx: 12,
    fill: "#ffffff"
  }), /*#__PURE__*/React.createElement("text", {
    x: 300,
    y: 388,
    textAnchor: "middle",
    fill: "#4a3f66"
  }, "Integration"), /*#__PURE__*/React.createElement("rect", {
    x: 405,
    y: 360,
    width: 130,
    height: 44,
    rx: 12,
    fill: "#ffffff"
  }), /*#__PURE__*/React.createElement("text", {
    x: 470,
    y: 388,
    textAnchor: "middle",
    fill: "#4a3f66"
  }, "End-to-End"), /*#__PURE__*/React.createElement("rect", {
    x: 565,
    y: 360,
    width: 150,
    height: 44,
    rx: 12,
    fill: "#ffffff"
  }), /*#__PURE__*/React.createElement("text", {
    x: 640,
    y: 388,
    textAnchor: "middle",
    fill: "#4a3f66"
  }, "Performance"))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgQaTestingIllustration);
export default __webpack_public_path__ + "static/media/qa-testing-illustration.0a5b3be6a09c009e75d64eca245ef350.svg";
export { ForwardRef as ReactComponent };